import React from "react";

const HelpMessage = () => {
  return (
    <div className="HelpMessage">
      Please contact Milk Collection at UDS AB if you have problems or questions
      about the app Tel: 01 443 3481
    </div>
  );
};

export default HelpMessage;
